import { render, staticRenderFns } from "./AssignPermissionRole.vue?vue&type=template&id=540a23c1&"
import script from "./AssignPermissionRole.vue?vue&type=script&lang=js&"
export * from "./AssignPermissionRole.vue?vue&type=script&lang=js&"
import style0 from "./AssignPermissionRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports